import type { Post } from "../../lib/posts";
import { getRelatedPosts } from "../../lib/posts";
import { ArticleCard } from "./ArticleCard";

type RelatedPostsProps = {
  post: Post;
};

export function RelatedPosts({ post }: RelatedPostsProps) {
  const relatedPosts = getRelatedPosts(post);

  if (relatedPosts.length === 0) return null;

  return (
    <section className="related-posts" aria-labelledby="related-articles">
      <h2 id="related-articles">Related Articles</h2>
      <div className="article-list article-list--compact">
        {relatedPosts.map((relatedPost) => (
          <ArticleCard key={relatedPost.slug} post={relatedPost} />
        ))}
      </div>
    </section>
  );
}
